import { configure, defineRule } from 'vee-validate'
import * as veeRules from '@vee-validate/rules';
import jsGlobalConfig from "../services/getJsGlobalConfig";

const validations = {

  street() {
    return /^([A-Za-zßäüöÄÜÖ._+&'-]+-?\s?)*[1-9][0-9]*[A-Za-z]*/;
  },

  zipCode() {
    return /\d{5}$/;
  },

  city() {
    return /^([^0-9]*)$/;
  },

  email(value) {
    // eslint-disable-next-line no-useless-escape
    return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value);
  },

  passwordRegex() {
    const specialCharsPassword = jsGlobalConfig().getPasswordSpecialChars();
    return "(.*[0-9]+.*[a-z]+.*[A-Z]" + specialCharsPassword + ")"
      + "|(.*[0-9]+.*[a-z]+" + specialCharsPassword + "[A-Z].*)"
      + "|(.*[0-9]+.*[A-Z].*[a-z]+" + specialCharsPassword + ")"
      + "|(.*[0-9]+.*[A-Z]" + specialCharsPassword + "[a-z]+.*)"
      + "|(.*[0-9]+" + specialCharsPassword + "[a-z]+.*[A-Z].*)"
      + "|(.*[0-9]+" + specialCharsPassword + "[A-Z].*[a-z]+.*)"
      + "|(.*[a-z]+.*[0-9]+.*[A-Z]" + specialCharsPassword + ")"
      + "|(.*[a-z]+.*[0-9]+" + specialCharsPassword + "[A-Z].*)"
      + "|(.*[a-z]+.*[A-Z].*[0-9]+" + specialCharsPassword + ")"
      + "|(.*[a-z]+.*[A-Z]" + specialCharsPassword + "[0-9]+.*)"
      + "|(.*[a-z]+" + specialCharsPassword + "[0-9]+.*[A-Z].*)"
      + "|(.*[a-z]+" + specialCharsPassword + "[A-Z].*[0-9]+.*)"
      + "|(.*[A-Z]+.*[0-9]+.*[a-z]" + specialCharsPassword + ")"
      + "|(.*[A-Z]+.*[0-9]+" + specialCharsPassword + "[a-z].*)"
      + "|(.*[A-Z]+.*[a-z].*[0-9]+" + specialCharsPassword + ")"
      + "|(.*[A-Z]+.*[a-z]" + specialCharsPassword + "[0-9]+.*)"
      + "|(.*[A-Z]+" + specialCharsPassword + "[0-9]+.*[a-z].*)"
      + "|(.*[A-Z]+" + specialCharsPassword + "[a-z].*[0-9]+.*)"
      + "|(" + specialCharsPassword + "[0-9]+.*[a-z].*[A-Z]+.*)"
      + "|(" + specialCharsPassword + "[0-9]+.*[A-Z]+.*[a-z].*)"
      + "|(" + specialCharsPassword + "[a-z].*[0-9]+.*[A-Z]+.*)"
      + "|(" + specialCharsPassword + "[a-z].*[A-Z]+.*[0-9]+.*)"
      + "|(" + specialCharsPassword + "[A-Z]+.*[0-9]+.*[a-z].*)"
      + "|(" + specialCharsPassword + "[A-Z]+.*[a-z].*[0-9]+.*)";
  },
  passwordMin() {
    return jsGlobalConfig().getPasswordMin();
  },
  passwordMax() {
    return jsGlobalConfig().getPasswordMax();
  }
}

export default function configureVeeValidate(messages) {

  defineRule('required', veeRules.required)
  defineRule('email', veeRules.email)
  defineRule('min', (value, [min]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }

    const r = validations[min]?.() ?? min

    return veeRules.min(value, [r])
  })
  defineRule('min_value', veeRules.min_value)
  defineRule('max', (value, [max]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }

    const r = validations[max]?.() ?? max

    return veeRules.max(value, [r])
  })
  defineRule('max_value', veeRules.max_value)
  defineRule('regex', (value, [regex]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }

    const r = validations[regex]?.() ?? regex

    return veeRules.regex(value, [r])
  })
  defineRule('confirmed', veeRules.confirmed)
  defineRule('ext', veeRules.ext)
  defineRule('size', veeRules.size)


  configure({
    generateMessage: (context) => {

      const fieldName = context.name !== '{field}' ? context.name : context.rule.name

      let key = `validation.custom.${fieldName}.${context.rule.name}`;
      /**@type String*/
      let text = messages[window.__globalConfig.country || 'de'][key];

      if (!text) {
        text = messages[window.__globalConfig.country || 'de'][`validation.messages.${context.rule.name}`]
      }

      if (!text) {
        return key
      }

      if (context.rule.params) {
        for (let i = 0; i < context.rule.params.length; i++) {
          text = text.replaceAll(`{${i + 1}}`, context.rule.params[i])
        }
      }

      return text
    },
  });

}

